import $ from "jquery";

export function flowTab() {
    if (document.getElementById('flowtable')){
        //Event
        $('#plan > li > a').on('click', function(e) {
            e.preventDefault();

            let i = $(this).parent('li');// eslint-disable-line

            //非表示にする
            $('#table > p img').stop().animate({'opacity':'0'}, 100);
            $('.flow_history > li > ul > li').stop().animate({'opacity':'0'}, 100);
            $('.column-3 > li').stop().fadeOut('slow/400/fast');

            //フラグを立てる
            if (i.attr('class') === 'flag') {
                i.removeClass('flag');
            }else{
                i.addClass('flag');
            }

            //繰り返し（表示する）
            $('#plan > li.flag').each(function() {

                let flaid = $(this).attr('id').replace('plan', '');
                let iconcls = 'icon' + flaid;
                let tableid = 'table' + flaid;
                let colid = 'col' + flaid;

                $('#table > p#' + tableid + '> img').animate({'opacity':'1'});
                $('.flow_history > li > ul > li.' + iconcls).animate({'opacity':'1'});
                $('.column-3 > li#' + colid).fadeIn('slow/400/fast').addClass('over');
            });
        });
    }
}